export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14210.4610a1fb.jpg";